import SearchNav from "./search-box"

export default SearchNav
